import styled from "styled-components";
import { Button } from "./Core";
import { resolveIcon } from "../../styles/icons";

const WrapperButton = styled(Button)` 
    height: ${props => (props.$size ?  props.$size : '2rem')};
    width: ${props => (props.$size ?  props.$size : '2rem')};
    padding: 0px;
    box-shadow: ${ ({theme}) => theme.card.boxShadow };
    display: inline-flex;
    align-items: center;
    justify-content: center;
    position: relative;
    font-weight: 800;
    border-radius: ${props => (props.$rounded ? '2rem' : '')};
    flex-shrink: 0;

&>svg{
    width: 60%;
    height: 60%;
}


`

// `title` is the hover tooltip — worth giving whenever the icon alone does not say what the button does.
const IconButton = ({ icon, $variant, clickAction, $rounded, $size, disabled, testId, ariaLabel, title, $marginRight }) => {
    return (
        <WrapperButton $marginRight={$marginRight} type="button" disabled={disabled?disabled:false} $variant={$variant} $rounded={$rounded} $size={$size} onClick={(clickAction)} data-testid={testId} aria-label={ariaLabel} title={title}>
            {resolveIcon(icon)}
        </WrapperButton>
    )

}

export default IconButton